import { useMatches } from "@tanstack/react-router"

/** True when the active route opted out of SKU-store hydration via skipSkuStoreData. */
export const useSkipSkuStoreData = () =>
  useMatches({
    select: (matches) => matches.some((m) => m.staticData.skipSkuStoreData === true),
  })
